/**
 * Runtime configuration.
 *
 * Read from `window.__SHIFT_ENV__`, written by the container entrypoint, so one
 * built image runs in every environment. `import.meta.env` is used only as the
 * development fallback.
 */
export interface RuntimeEnv {
  apiBaseUrl: string;
  appEnv: string;
}

export const runtimeEnv: RuntimeEnv = {
  apiBaseUrl: window.__SHIFT_ENV__?.API_BASE_URL ?? '/api/v1',
  appEnv: window.__SHIFT_ENV__?.APP_ENV ?? import.meta.env.MODE,
};

export const isProductionBuild = import.meta.env.PROD;
